import { VehicleStatus } from "../../models/Vehicle";
import formatDateTime from "../../utils/formatDateTime";
import Tooltip from "../shared/Tooltip";

export default function VehicleStatusCell({
  status,
  statusDate,
}: {
  status: VehicleStatus;
  statusDate?: string | null;
}) {
  let className = "rounded-full px-3 py-1 text-xs font-semibold ";
  switch (status) {
    case VehicleStatus["Not On Site"]:
      className += "bg-gray-100 text-gray-800";
      break;
    case VehicleStatus["On Site"]:
      className += "bg-blue-100 text-blue-600";
      break;
    case VehicleStatus["Awaiting Dismantling"]:
      className += "bg-yellow-100 text-yellow-600";
      break;
    case VehicleStatus.Dismantled:
      className += "bg-purple-100 text-purple-600";
      break;
    case VehicleStatus.Scrapped:
      className += "bg-red-100 text-red-600";
      break;
  }

  const tooltip = statusDate
    ? `Vehicle Status — set ${formatDateTime(statusDate)}`
    : "Vehicle Status";

  return (
    <div className="flex flex-col justify-center items-center flex-1 text-nowrap gap-4">
      <span title="Vehicle Status">
        <Tooltip content={tooltip}>
          <span className={className}>{VehicleStatus[status]}</span>
        </Tooltip>
      </span>
    </div>
  );
}
